/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AllCommentsTabCommentContainer_comment = {
    readonly enteredLive: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "AllCommentsTabCommentContainer_comment";
};
export type AllCommentsTabCommentContainer_comment$data = AllCommentsTabCommentContainer_comment;
export type AllCommentsTabCommentContainer_comment$key = {
    readonly " $data"?: AllCommentsTabCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabCommentContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabCommentContainer_comment",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enteredLive",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '1d0e13b4944f8fa63939dfd1835e73e8';
export default node;
